import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  HStack,
  Spinner,
  Text,
  Button,
} from '@chakra-ui/react';
import { FiEye } from 'react-icons/fi';
import { tenantHeaders } from '../tenant';

const API_BASE = '/api/v1';

function SyncRuns() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewingRun, setViewingRun] = useState(null);
  
  const { isOpen: isViewOpen, onOpen: onViewOpen, onClose: onViewClose } = useDisclosure();

  const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Token ${localStorage.getItem('token')}`,
    ...tenantHeaders(),
  });

  const fetchRuns = () => {
    fetch(`${API_BASE}/sync-runs/`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => {
        setRuns(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchRuns();
  }, []);

  const openViewRun = (run) => {
    fetch(`${API_BASE}/sync-runs/${run.id}/`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => {
        setViewingRun(data);
        onViewOpen();
      });
  };

  if (loading) {
    return <Box textAlign="center" py={20}><Spinner size="xl" color="orange.500" /></Box>;
  }

  return (
    <Box>
      <Heading size="lg" mb={6}>Sync Runs</Heading>

      <Box bg="white" p={6} borderRadius="lg" boxShadow="md" overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>List Created</Th>
              <Th>Contacts Created</Th>
              <Th>Contacts Updated</Th>
              <Th>Contacts Deleted</Th>
              <Th>Created</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {runs.map(run => (
              <Tr key={run.id}>
                <Td fontWeight="medium">#{run.id}</Td>
                <Td>
                  <Badge colorScheme={run.list_created ? 'green' : 'gray'}>
                    {run.list_created ? 'Yes' : 'No'}
                  </Badge>
                </Td>
                <Td><Badge colorScheme="blue">{run.contacts_created}</Badge></Td>
                <Td><Badge colorScheme="yellow">{run.contacts_updated}</Badge></Td>
                <Td><Badge colorScheme="red">{run.contacts_deleted}</Badge></Td>
                <Td>{new Date(run.created_at).toLocaleString()}</Td>
                <Td>
                  <HStack spacing={2}>
                    <IconButton
                      icon={<FiEye />}
                      size="sm"
                      variant="ghost"
                      onClick={() => openViewRun(run)}
                      aria-label="View"
                    />
                  </HStack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {runs.length === 0 && (
          <Text color="gray.500" textAlign="center" py={8}>No sync runs found</Text>
        )}
      </Box>

      {/* View Modal */}
      <Modal isOpen={isViewOpen} onClose={onViewClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sync Run Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewingRun && (
              <>
                <Text><strong>ID:</strong> #{viewingRun.id}</Text>
                <Text><strong>List Created:</strong> {viewingRun.list_created ? 'Yes' : 'No'}</Text>
                <Text><strong>Contacts Created:</strong> {viewingRun.contacts_created}</Text>
                <Text><strong>Contacts Updated:</strong> {viewingRun.contacts_updated}</Text>
                <Text><strong>Contacts Deleted:</strong> {viewingRun.contacts_deleted}</Text>
                <Text><strong>Created:</strong> {new Date(viewingRun.created_at).toLocaleString()}</Text>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onViewClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default SyncRuns;
